export const CoreFeatures = {
  CORE: 'CORE',
  HOST_LIMIT: 'HOST_LIMIT',
  PRIVATE_HOSTS: 'PRIVATE_HOSTS',
  ADDITIONAL_BADGES: 'ADDITIONAL_BADGES',
  WORKPLACE_EXPERIENCES: 'WORKPLACE_EXPERIENCES',
  ZONES: 'ZONES',
  LOBBY_MODE: 'LOBBY_MODE',
  OUTLOOK_ADDIN: 'OUTLOOK_ADDIN',
  PUBLIC_API: 'PUBLIC_API',
  ELASTICSEARCH: 'ELASTICSEARCH',
  CHECKLISTS_IDENTIFIER: 'CHECKLISTS_IDENTIFIER',
  ADVANCED_CHECKLISTS: 'ADVANCED_CHECKLISTS',
  MESSAGE_BROADCAST: 'MESSAGE_BROADCAST',
};

export const FeaturesByProduct = {
  CORE: Object.values(CoreFeatures),
  WORKFLOWS: [
    'WORKFLOWS',
    'WORKFLOWS_SMS_ENABLED',
    'WORKFLOW_PERMITS',
    'WORKFLOWS_MULTIPLE_APPROVALS',
    'WORKFLOWS_QRCODE_ENABLED',
    'WORKFLOWS_WEBHOOK_INTEGRATION',
  ],
  COMPANIES: [
    'CONNECT_WORKFLOWS_INTEGRATION',
    'CONNECT_COMPANY_STATUS',
    'CONNECT_COMPANY_DOCUMENTS',
    'COMPANIES_REQUEST_DOCUMENTS',
    'COMPANIES_COMPANY_CATEGORIES',
  ],
  SCHEDULING: ['SCHEDULING'],
  ADMIN: ['ADMIN_DASHBOARD', 'ADMIN_PEOPLE', 'ADMIN_PLUGINS'],
};

export const featureToolTipValues = {
  'Advanced Checklists': 'This feature should only be enabled for Teams with Medium Sites',
};
